import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ListItem} from '../models/list-item';
import {User} from '../models/user';
import {KvItem} from '../models/kv-item';
import {Observable} from 'rxjs/Observable';
import * as fromRoot from '../reducers';
import * as userActions from '../actions/user';
import * as listActions from '../actions/list';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-user-editor',
  template: `<div class="row form-group justify-content-center">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header">
            <user-editor-header [isNewUser]="isNewUser$ | async"></user-editor-header>
        </div>
        <div class="card-body">
          <user-form [user]="currentUser$ | async" 
                     [isNewUser]="isNewUser$ | async"
                     [roles]="roles$ | async"
                     [working]="userWorking$ | async"
                     [usernameTaken]="usernameExists$ | async"
                     [emailTaken]="emailExists$ | async"
                     (saveUser)="save($event)"
                     (checkUsername)="checkUsername($event)"
                     (checkEmail)="checkEmail($event)"></user-form>
        </div>
      </div>
    </div>
  </div>
  `
})
export class UserEditorPageComponent implements OnInit {

  public currentUser$: Observable<User>;
  public isNewUser$: Observable<boolean>;
  public roles$: Observable<KvItem[]>;
  public working$: Observable<boolean>;
  public userWorking$: Observable<boolean>;
  public usernameExists$: Observable<boolean>;
  public emailExists$: Observable<boolean>;

  constructor(private route: ActivatedRoute,
              private store: Store<fromRoot.State>) {
    this.currentUser$ = this.store.select(fromRoot.getSelectedUser);
    this.isNewUser$ = this.store.select(fromRoot.getIsNewUser);
    this.roles$ = this.store.select(fromRoot.getUserRoles);
    this.working$ = this.store.select(fromRoot.getAuthWorking);
    this.userWorking$ = this.store.select(fromRoot.getUserWorking);
    this.usernameExists$ = this.store.select(fromRoot.getUsernameExists);
    this.emailExists$ = this.store.select(fromRoot.getEmailExists);

    this.store.dispatch(new userActions.LoadUserRolesAction());
  }

  save(usr: User) {
    this.store.dispatch(new userActions.SaveUserDetailsAction(usr));
  }

  checkUsername(username: string) {
    this.store.dispatch(new userActions.CheckUsernameExistsAction(username));
  }

  checkEmail(email: string) {
    this.store.dispatch(new userActions.CheckEmailExistsAction(email));
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const username = params['id'];
      if (username) {
        this.store.dispatch(new userActions.LoadUserDetailsAction(decodeURIComponent(username)));
      } else {
        this.store.dispatch(new userActions.LoadUserDetailsAction(''));
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/user-editor.ts